import { render, staticRenderFns } from "./ResumeDetailsApply.vue?vue&type=template&id=773494e4&scoped=true&"
import script from "./ResumeDetailsApply.vue?vue&type=script&lang=ts&"
export * from "./ResumeDetailsApply.vue?vue&type=script&lang=ts&"
import style0 from "./ResumeDetailsApply.vue?vue&type=style&index=0&id=773494e4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "773494e4",
  null
  
)

export default component.exports